import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  CLIENT_SSO_ENTRY_PATH,
  isClientSsoAllowedPath,
} from "../../constants/clientSso";

const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.user.userInfo
  );

  if (isAuthenticated) {
    return children;
  }

  if (isClientSsoAllowedPath(window.location.pathname)) {
    return <Navigate to={CLIENT_SSO_ENTRY_PATH} replace />;
  }

  return <Navigate to="/auth/login" />;
};

export default PrivateRoute;
